import { IntlProvider } from 'react-intl';
import useMessages from 'hooks/use_messages';

const Intl = ({ children, locale }) => {
  const messages = useMessages();

  return (
    <IntlProvider locale={locale} messages={messages[locale]}>
      {children}
    </IntlProvider>
  );
};

export default Intl;
